export default "__VITE_PUBLIC_ASSET__59421248__"